/**
 * @see https://www.figma.com/file/MyZgoSllejDOT7yjI4UZFv/Azzurri-Design-System?node-id=6935%
 * @example import { palette } from 'assets/colors  --->  palette.blue[300]
 */

const blue = {
  50: '#CCE3F1',
  100: '#93B2C6',
  200: '#6D8FA4',
  300: '#4C6B7D',
  400: '#3D5F74',
  500: '#263D4B',
  600: '#142C3A',
  700: '#0C202D',
  800: '#081720',
};

const cactus = {
  50: '#C7FAEF',
  100: '#62D2BB',
  200: '#51C5AC',
  300: '#41BBA2',
  400: '#3AB199',
  500: '#35A38C',
  600: '#2E7F6E',
  700: '#297464',
  800: '#265148',
};

const sunshine = {
  50: '#FEF9EC',
  100: '#FFF1C2',
  200: '#FFE798',
  300: '#FBDD7B',
  400: '#F2CF58',
  500: '#EEC53E',
  600: '#CDAE47',
  700: '#B89E48',
  800: '#988546',
  900: '#D77348',
};

const pink = {
  50: '#FFE2E3',
  100: '#FFB8BA',
  200: '#FF9B9F',
  300: '#FF8D91',
  400: '#FF7479',
  500: '#EC6166',
  600: '#E2585D',
  700: '#CC5257',
  800: '#93373A',
};

const neutral = {
  50: '#F1F0EC',
  100: '#E8E6DF',
  200: '#DDDAD1',
  300: '#C7C4BB',
  400: '#B5B2A9',
  500: '#9A9890',
  600: '#75736C',
  700: '#494842',
  800: '#32312D',
};

const tierPalette = {
  level1: '#57616D',
  level2: '#263D4B',
  level3: '#0A292E',
  level4: '#FEFAEF',
};

const palette = {
  neutral,
  blue,
  cactus,
  sunshine,
  pink,
};

export { palette, tierPalette };
